import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import { DayOfWeek } from "@js-joda/core";
import { validationRules } from "@/ValidationRules";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PriceRow',
    props: {
        label: { type: String, required: false },
        priceType: { type: String, required: true },
        referenceId: { type: [Number, Object], default: null },
        prices: { type: Object, required: true }
    },
    emits: ['update:price', 'update:lowerBound'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function getPrice(day) {
            return props.prices.get(day)?.get(props.priceType)?.get(props.referenceId);
        }
        function onPriceUpdated(day, amount, lowerBound) {
            // convert text input to number. When undefined, the field was not updated and we keep it's current value.
            // Empty string (deleting an input) becomes 0.
            let numAmount = Number(amount == undefined ? getPrice(day)?.amount : amount);
            let numLowerBound = Number(lowerBound == undefined ? getPrice(day)?.lowerBound : lowerBound);
            emit('update:price', day, props.priceType, props.referenceId, Number.isNaN(numAmount) || numAmount == 0 ? undefined : numAmount, Number.isNaN(numLowerBound) || numLowerBound == 0 ? undefined : numLowerBound);
        }
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, _toDisplayString(__props.label), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DayOfWeek).values(), (day) => {
                    return (_openBlock(), _createElementBlock("td", {
                        key: day.value()
                    }, [
                        _createVNode(_component_v_text_field, {
                            class: "pt-2",
                            density: "compact",
                            rules: [_unref(validationRules).currency, _unref(validationRules).nonNegative],
                            "hide-details": true,
                            "model-value": getPrice(day)?.amount,
                            onInput: ($event) => (onPriceUpdated(day, $event.target.value, undefined)),
                            label: "Preis",
                            type: "number",
                            variant: "outlined",
                            suffix: "€",
                            "data-cy": "price"
                        }, null, 8, ["rules", "model-value", "onInput"]),
                        _createVNode(_component_v_text_field, {
                            density: "compact",
                            rules: [_unref(validationRules).currency, _unref(validationRules).nonNegative],
                            "hide-details": true,
                            "model-value": getPrice(day)?.lowerBound,
                            onInput: ($event) => (onPriceUpdated(day, undefined, $event.target.value)),
                            placeholder: "0",
                            label: "Min. Preis",
                            type: "number",
                            variant: "outlined",
                            suffix: "€",
                            class: "min-price-field pt-2",
                            "data-cy": "min-price"
                        }, null, 8, ["rules", "model-value", "onInput"])
                    ]));
                }), 128))
            ]));
        };
    }
});
